export enum Environments {
	DEV = 'dev',
	STAGING = 'staging',
	PROD = 'prod'
}
